module.exports = __webpack_public_path__ + "static/media/bg_05_clean.7f4a264d.jpg";